module.exports = __webpack_public_path__ + "static/media/layout_double_active.9701bfb5.svg";